const Dashboard = () => import("@/components/vigico/dashboard/Dashboard.vue");
const Leads = () => import("@/components/vigico/leads/Leads.vue");
const PAC = () => import("@/components/vigico/pac/PAC.vue");
const Appointments = () =>
  import("@/components/vigico/appointments/Appointments.vue");
const Administration = () =>
  import("@/components/vigico/administration/Administration.vue");
const UserProfile = () => import("@/components/vigico/UserProfile.vue");

export default [
  {
    path: "",
    redirect: "dashboard",
  },
  {
    path: "dashboard",
    name: "Dashboard",
    component: Dashboard,
  },
  {
    path: "leads",
    name: "Leads",
    component: Leads,
  },
  {
    path: "pac",
    name: "PAC",
    component: PAC,
  },
  {
    path: "appointments",
    name: "Appointments",
    component: Appointments,
  },
  {
    path: "administration",
    name: "Administration",
    component: Administration,
    meta: { requiresFullAccess: true },
  },
  {
    path: "profile",
    name: "user-profile",
    component: UserProfile,
  },
];
